import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import { wsGetAll } from 'services/WService';

import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

export default function ModalQuotaZone(props) {
  const quotaZone = props.model;
  const [dataChanging, setDataChanging] = useState(quotaZone);
  const [zones, setZones] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState({});

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  useEffect(() => {
    if (quotaZone.open) listZones();
  }, [quotaZone.open]);

  return (
    <Modal
      title="Comisión básica"
      model={quotaZone}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      dataForce={{ ...bPartnerSelect }}
      entity="com/zone-quota"
      state
    >
      <TextField
        label="Periodo"
        fullWidth
        type="month"
        name="period_date"
        margin="normal"
        defaultValue={moment().format('YYYY-MM') || ''}
        InputLabelProps={{ shrink: true }}
        required
        disabled={!!quotaZone.id}
      />

      <TextField
        label="Básico"
        fullWidth
        type="number"
        name="quota"
        margin="normal"
        defaultValue={quotaZone?.quota || ''}
        inputProps={{ min: 0, step: 0.01 }}
        required
      />

      <FormControl fullWidth margin="normal">
        <InputLabel>Zona</InputLabel>
        <Select
          defaultValue={quotaZone.base_zone_id || ''}
          inputProps={{ name: 'base_zone_id' }}
          disabled={!!quotaZone.id}
        >
          {zones.map((item, i) => {
            return (
              <MenuItem key={i} value={item.id}>
                {item.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      {!!quotaZone.id ? (
        <TextField
          label="Cliente"
          fullWidth
          margin="normal"
          defaultValue={quotaZone.CardName || ''}
          required
          disabled={!!quotaZone.id}
        />
      ) : (
        <FilterCustom
          fullWidth
          getFilter={setBPartnerSelect}
          commissions={[
            { key: 'R', label: 'Jefe reparto' },
            { key: 'M', label: 'Encargado mercadería' },
            { key: 'S', label: 'Supervisor' }
          ]}
          commissionField="type"
          jefe
        />
      )}
    </Modal>
  );
}
